@if(isDisabled){
<app-loader></app-loader>
}

<div class="card border-radius-0 mt-1 p-0">
    <div class="card-header">
        Transfer Order
    </div>
    <div class="card-body" style="width: 100%; overflow: auto;">
        <div class="mt-4">
            <table datatable [dtOptions]="this.dtoptions" [dtTrigger]="dtTrigger" class="table table-bordered pt-2"
                style="width: 100%; overflow: auto;">
                <thead class="table-light">
                    <tr>
                        <th style="width: 5px;">#</th>
                        <th>Entry No.</th>
                        <th>Employee Code</th>
                        <th>Employee Name</th>
                        <th>Branch Name</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let element of TableData ;let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td> {{element['TransactionNo']}}</td>
                        <td> {{element['EmpCode']}}</td>
                        <td> {{element['Employee Name']}}</td>
                        <td> {{element['BranchName']}}</td>
                        <td style="width: 5px;">
                            <div class="text-center">
                                <i class="bi bi-pencil-square text-warning"
                                    [routerLink]="['/allocation/zinghr/add/',element['ID']]">
                                </i>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" name="sample" (click)="exportToExcel()">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>&nbsp;&nbsp;
            </div>
        </div>
    </div>
</div>